module.exports = __webpack_public_path__ + "media/ב.1b5025bc.mp3";